import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Spinner, Text, VStack } from '@chakra-ui/react'
import { auth } from '../../config/firebase'
import { onAuthStateChanged } from 'firebase/auth'

interface AdminRouteGuardProps {
  children: React.ReactNode
}

export const AdminRouteGuard: React.FC<AdminRouteGuardProps> = ({ children }) => {
  const navigate = useNavigate()
  const [isAdmin, setIsAdmin] = useState<boolean | null>(null)
  const [initializing, setInitializing] = useState(true)

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const token = await user.getIdTokenResult()
          const adminClaim = token.claims.admin === true
          
          if (adminClaim) {
            localStorage.setItem('firebase_id_token', token.token)
            setIsAdmin(true)
          } else {
            setIsAdmin(false)
            // Redirect to home if not admin
            navigate('/', { replace: true })
          }
        } catch (error) {
          console.error('Failed to get token:', error)
          setIsAdmin(false)
          navigate('/', { replace: true })
        } finally {
          setInitializing(false)
        }
      } else {
        setIsAdmin(false)
        setInitializing(false)
        navigate('/', { replace: true })
      }
    })

    return () => unsubscribe()
  }, [navigate])

  if (initializing) {
    return (
      <Box
        minH="100vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
        bg="gray.50"
      >
        <VStack gap={4}>
          <Spinner size="xl" color="brand.500" />
          <Text color="gray.600">Checking admin access...</Text>
        </VStack>
      </Box>
    )
  }

  if (!isAdmin) {
    return null // Will redirect
  }

  return <>{children}</>
}

